module.exports = __webpack_public_path__ + "assets/img/font5.f189d700.png";